export default "__VITE_ASSET__hovajide__"